export class MergeField {
    constructor() { }
}